//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PublicService from '@/service/public'
export default {
    props: {},
    data () {
        return {
            mobile: '',
            weixin_name: '',
            intention: '',
            maxlength: 300
        }
    },
    methods: {
        submit(e) {
            const { mobile: mobile_el, weixin_name: weixin_name_el, intention: intention_el } = e.target
            const mobile = mobile_el.value
            const weixin_name = weixin_name_el.value
            const intention = intention_el.value
            const canSubmit = [{
                tips: '请授权手机号',
                value: mobile
            }, {
                tips: '请输入您的微信号',
                value: weixin_name
            }, {
                tips: '请简要说明合作意向',
                value: intention
            }].every(item => {
                if (item.value.trim() === '') {
                    this.onShowToast(item.tips)
                    return false
                }
                return true
            })
            if (intention.length > this.maxlength) {
                this.onShowToast(`合作意向不能超过${this.maxlength}个字!`)
                return
            }
            if (canSubmit) {
                PublicService.postBusinessCooperations({
                    mobile,
                    weixin_name,
                    intention: intention.substr(0, this.maxlength)
                }).then(() => {
                    wx.hideLoading()
                    wx.showToast({
                        title: '提交成功'
                    })
                    this.$router.back()
                })
            }
        },
        getPhoneNumber (e) {
            const { iv, encryptedData, errMsg, code } = e.target
            PublicService.postWeixinPhone(iv, encryptedData, errMsg, { code }).then((data) => {
                if (Number(data.code) === 422) {
                    wx.showToast({
                        title: data.error_message,
                        icon: 'none'
                    })
                } else {
                    this.mobile = data.phone
                }
            })
        },
        onShowToast (tips) {
            wx.showToast({
                title: tips,
                icon: 'none',
                duration: 2000
            })
        },
    }
}
